import { AnyObject } from "@hen/stdlib/types";
import _ from "lodash";

import { getProposedBonus } from "./bonus";
import { Proposal } from "./types";

export function getOutlierData(proposal: Proposal): AnyObject {
  return proposal.outlierData as AnyObject;
}

export function getHasOutliers(proposal: Proposal): boolean {
  const outlierData = getOutlierData(proposal);

  return !_.every(
    // we just want the "show/hide" boolean values of each check
    _.omit(outlierData, [
      "salaryBandMinDiff",
      "salaryBandMaxDiff",
      "salaryIncreaseDiff",
      "bonusAwardDiff",
      "proposedEquityDiff",
    ]),
    (value, key) => {
      switch (key) {
        case "salaryIncreaseLowEnabled":
        case "salaryIncreaseHighEnabled":
          return !(value && !_.isNull(proposal.raise));
        case "bonusAwardLowEnabled":
        case "bonusAwardHighEnabled":
          return !(value && !_.isNull(getProposedBonus(proposal)));
        // todo: include grants with proposal and iterate through to check for values.
        // case "proposedEquityLowEnabled": case "proposedEquityHighEnabled":
        //   break;
        default:
          return !value;
      }
    },
  );
}
